import React from 'react';
import { Icon } from './Icon.js';
export const IconCompose2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M13.5355 14L21.7678 5.76777L20 4.00001L18.2322 2.23224L9.99994 10.4645V14L13.5355 14Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M12.2266 4H4V20H20V11.7793L22 9.7793V22H2V2H14.2266L12.2266 4Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconCompose2.js.map